/* eslint-disable react/prop-types */
import * as React from "react";
import { useState } from "react";
import {
    Tabs,
    Tab,
    Box,
    ThemeProvider,
    Typography,
    Container,
} from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import ProductsOverview from "./ProductsOverview/ProductsOverview";
import Gallery5 from "./gallery5/Gallery5";
import TTTAcademy from "./tttAcademy/TTTAcademy";
import TTT from "./TTT/TTT";
import BBS from "./bbs/BBS";
import U25 from "./u25/U25";
import InstagramChannelAnalytics from "./instagramChannelAnalytics";
import CreatorsTech from "./creatorsTech/CreatorsTech";

const StyledTabs = styled(Tabs)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.neutral[200]}`,
    "& .MuiTabs-indicator": {
        backgroundColor: theme.palette.secondary[500],
    },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    "&.Mui-selected": {
        color: theme.palette.secondary[500],
    },
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const AdminDashboard = () => {
    const [value, setValue] = useState(0);
    const theme = useTheme();

    // Hardcoded tabs
    const tabs = [
        // { title: "Product Roadmap", id: "product-roadmap" },
        {
            title: "Channels",
            id: "instagram-channel-analytics",
        },
        { title: "BBS", id: "bbs" },
        { title: "Galleri5", id: "gallery5" },
        { title: "Academy", id: "academy" },
        { title: "TTT", id: "ttt" },
        { title: "Under 25", id: "under25" },
        {
            title: "Creators Tech",
            id: "creatorstech",
        },
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const renderContent = () => {
        const selectedTab = tabs[value];

        if (!selectedTab) return <div>Select a tab</div>;

        switch (selectedTab.title) {
            case "Product Roadmap":
                return <ProductsOverview />;
            case "BBS":
                return <BBS />;
            case "Galleri5":
                return <Gallery5 />;
            case "Academy":
                return <TTTAcademy />;
            case "TTT":
                return <TTT />;
            case "Under 25":
                return <U25 />;
            case "Channels":
                return <InstagramChannelAnalytics />;
            case "Creators Tech":
                return <CreatorsTech />;
            default:
                return <div>Unknown tab: {selectedTab.title}</div>;
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <Container sx={{ width: "100%" }}>
                <Typography variant="featureAccent">
                    Vijay&apos;s Dashboard
                </Typography>

                <Box
                    mt={3}
                    sx={{
                        borderBottom: 1,
                        borderColor: theme.palette.neutral[200],
                    }}
                >
                    <StyledTabs
                        value={value}
                        onChange={handleChange}
                        aria-label="admin dashboard tabs"
                    >
                        {tabs.map((tab, index) => (
                            <StyledTab
                                key={tab.id}
                                label={tab.title}
                                {...a11yProps(index)}
                            />
                        ))}
                    </StyledTabs>
                </Box>
                {tabs.map((tab, index) => (
                    <CustomTabPanel key={tab.id} value={value} index={index}>
                        {renderContent()}
                    </CustomTabPanel>
                ))}
            </Container>
        </ThemeProvider>
    );
};

export default AdminDashboard;
